<template>
    <div v-if="field && editor" class="editor-container">
        <div class="control-group">
            <div class="button-group">
                <b-button @click="editor.chain().focus().toggleHeading({ level: 1 }).run()" :variant="editor.isActive('heading', { level: 1 }) ? 'dark' : 'light'">
                H1
                </b-button>
                <b-button @click="editor.chain().focus().toggleHeading({ level: 2 }).run()" :variant="editor.isActive('heading', { level: 2 }) ? 'dark' : 'light'">
                H2
                </b-button>
                <b-button @click="editor.chain().focus().toggleHeading({ level: 3 }).run()" :variant="editor.isActive('heading', { level: 3 }) ? 'dark' : 'light'">
                H3
                </b-button>
                <b-button @click="editor.chain().focus().setParagraph().run()" :variant="editor.isActive('paragraph') ? 'dark' : 'light'" >
                Paragraph
                </b-button>
                <b-button @click="editor.chain().focus().toggleBold().run()" :variant="editor.isActive('bold') ? 'dark' : 'light'" >
                Bold
                </b-button>
                <b-button @click="editor.chain().focus().toggleItalic().run()" :variant="editor.isActive('italic') ? 'dark' : 'light'" >
                Italic
                </b-button>
                <b-button @click="editor.chain().focus().toggleStrike().run()" :variant="editor.isActive('strike') ? 'dark' : 'light'" >
                Strike
                </b-button>
                <b-button @click="editor.chain().focus().toggleHighlight().run()" :variant="editor.isActive('highlight') ? 'dark' : 'light'" >
                Highlight
                </b-button>
                <b-button @click="editor.chain().focus().setTextAlign('left').run()" :variant="editor.isActive({textAlign: 'left'}) ? 'dark' : 'light'" >
                Left
                </b-button>
                <b-button @click="editor.chain().focus().setTextAlign('center').run()" :variant="editor.isActive({textAlign: 'center'}) ? 'dark' : 'light'" >
                Center
                </b-button>
                <b-button @click="editor.chain().focus().setTextAlign('right').run()" :variant="editor.isActive({textAlign: 'right'}) ? 'dark' : 'light'" >
                Right
                </b-button>
                <b-button @click="editor.chain().focus().setTextAlign('justify').run()" :variant="editor.isActive({textAlign: 'justify'}) ? 'dark' : 'light'" >
                Justify
                </b-button>
                <b-button size="sm" :style="{backgroundColor: textColor,position: 'relative'}" @click="colorPicker"><input
                    style="visibility:hidden;padding:0"
                    type="color"
                    id="colorPicker"
                    @input="editor.chain().focus().setColor($event.target.value).run()"
                    :value="textColor"
                /></b-button>
                <b-dropdown :text="fontFamily" style="max-width:50px" variant="light">
                    <b-dropdown-item v-for="font in fonts" :key="font" @click="changeFontFamily(font)" variant="light"> {{ font }} </b-dropdown-item>
                </b-dropdown>
                <button class="btn"> 
                    <b-input-group prepend="Font size">
                        <b-input v-model="fontSize" style="max-width:75px" variant="light" /> 
                    </b-input-group>
                </button>
                <b-button :variant="currentSettings == 'table' ? 'dark' : 'light'" @click="currentSettings = 'table'">
                    <b-icon icon="table" />
                </b-button>
                <b-button variant="light" @click="triggerImageImport"> <b-icon icon="image" /> <b-form-file @input="imageChoosen" id="imageImport" style="display:none"/> </b-button>
                <b-row v-if="currentSettings" class="currentSettings">
                    <b-col cols="12"> 
                        <b-button variant="secondary" @click="editor.chain().focus().insertTable({ rows: 3, cols: 3, withHeaderRow: true }).run()">
                            Insert table
                        </b-button>
                        <b-button variant="secondary" @click="editor.chain().focus().addColumnBefore().run()">
                            Add column before
                        </b-button>
                        <b-button variant="secondary" @click="editor.chain().focus().addColumnAfter().run()">
                            Add column after
                        </b-button>
                        <b-button variant="secondary" @click="editor.chain().focus().deleteColumn().run()">
                            Delete column
                        </b-button>
                        <b-button variant="secondary" @click="editor.chain().focus().addRowBefore().run()">
                            Add row before
                        </b-button>
                        <b-button variant="secondary" @click="editor.chain().focus().addRowAfter().run()">
                            Add row after
                        </b-button>
                        <b-button variant="secondary" @click="editor.chain().focus().deleteRow().run()">
                            Delete row
                        </b-button>
                        <b-button variant="secondary" @click="editor.chain().focus().deleteTable().run()">
                            Delete table
                        </b-button>
                        <b-button variant="secondary" @click="editor.chain().focus().mergeCells().run()">
                            Merge cells
                        </b-button>
                        <b-button variant="secondary" @click="editor.chain().focus().splitCell().run()">
                            Split cell
                        </b-button>
                        <b-button variant="secondary" @click="editor.chain().focus().toggleHeaderColumn().run()">
                            Toggle header column
                        </b-button>
                        <b-button variant="secondary" @click="editor.chain().focus().toggleHeaderRow().run()">
                            Toggle header row
                        </b-button>
                        <b-button variant="secondary" @click="editor.chain().focus().toggleHeaderCell().run()">
                            Toggle header cell
                        </b-button>
                        <b-button variant="secondary" @click="editor.chain().focus().mergeOrSplit().run()">
                            Merge or split
                        </b-button>
                        <b-button variant="secondary" @click="editor.chain().focus().fixTables().run()">
                            Fix tables
                        </b-button>
                        <b-button variant="secondary" @click="editor.chain().focus().goToNextCell().run()">
                            Go to next cell
                        </b-button>
                        <b-button variant="secondary" @click="editor.chain().focus().goToPreviousCell().run()">
                            Go to previous cell
                        </b-button> 
                        <button class="btn"> 
                            <b-input-group prepend="Style">
                                <b-input v-model="tableBorderStyle" variant="light" /> 
                            </b-input-group>
                        </button>
                    </b-col>
                </b-row>
            </div>
           
        </div>
        <editor-content :editor="editor" class="editor"/>
    </div>
</template>

<script>
import { Editor, EditorContent } from '@tiptap/vue-2'
import { Node } from '@tiptap/vue-2'
import StarterKit from '@tiptap/starter-kit'
import Highlight from '@tiptap/extension-highlight'
import TextAlign from '@tiptap/extension-text-align'
import { Color } from '@tiptap/extension-color'
import TextStyle from '@tiptap/extension-text-style'
import Image from '@tiptap/extension-image'
import Table from '@tiptap/extension-table'
import TableCell from '@tiptap/extension-table-cell'
import TableHeader from '@tiptap/extension-table-header'
import TableRow from '@tiptap/extension-table-row'
import FontFamily from '@tiptap/extension-font-family'
import { Extension } from "@tiptap/core"
import { HardBreak } from '@tiptap/extension-hard-break';
import { Document } from '@tiptap/extension-document';

export default {
    name: "IdentityField_Text_Editor",
    components: {
        EditorContent,
        Editor
    },

    props: {
        field: {
            type: Object
        },
        value: {
            type: String,
            default: ""
        },
        store: {
            type: Object
        },
        translator: {
            type: Function
        }
    },

    data: function() {
        return {
            errors: [],
            editor: null,
            textColor: null,
            fontFamily: null,
            fonts: [
                'Arial',
                'Aptos',
                'Courier New',
                'Georgia',
                'Inter',
                'Comic Sans',
                'Serif',
                'Monospace',
                'Cursive',
            ],
            image: null,
            currentSettings: null,
            currentSelection: null
        }
    },

    computed: {
        content: {
            get() {
                return this.value;
            },

            set(val) {
                this.$emit('input', val);
            }
        },
        constraints() {
            let constr = this.field.constraints

            return constr
        },
        
        defaultColor() {
            const {default_color = "#000"} = this.constraints

            return default_color
        },

        fontSize: {
            get() {
                return this.editor.getAttributes("textStyle").fontSize || '12px'
            },

            set(val) {
                if (val > 100) {
                    val = 100
                }

                this.editor.commands.setFontSize(val).run()
            }
        },

        margins: {
            get() {
                const { margin } = this.editor.getAttributes('main');

                return margin || 0
            },

            set(val) {
                this.editor.commands.setDocumentMargins(val);
            }
        },

        tableBorderStyle: {
            get() {
                const { borderStyle = "2px solid #000" } = this.editor.getAttributes('tableCell')

                console.log("borderStyle", borderStyle)

                return borderStyle || "2px solid #000"
            },

            set(val) {
                this.editor.commands.setCellAttribute("borderStyle", val)
            }
        },

        enablePages() {
            const {enable_pages = false} = this.constraints

            return enable_pages
        }
    },
       
    watch: {
        content(val) {
            this.check(val)
            const div = document.createElement('div');
            div.innerHTML = val;

            if (div.innerHTML !== this.editor.getHTML()) {
                this.editor.commands.setContent(val, false, {
                    preserveWhitespace: "full",
                });
            }
        }
    },

    methods: {
        check(val) {
            if (val !== null) {
                val = val.replace(/(<([^>]+)>)/ig,"")
            } else {
                val = ""
            }
            
            this.errors = []

            if (val == "" && this.constraints.required) {
                 this.errors.push(this.translator("identityField.requiredField"))
            }
            
            if (this.constraints.length !== undefined) {
                if (this.constraints.length.max !== null && this.constraints.length.max > 0) {
                    if (val.length > this.constraints.length.max && val.length > 0) {
                        this.errors.push(
                            this.translator("identityField.cantBeMoreThenChars", {
                                max: this.constraints.length.max
                            })
                        )
                    }
                }
                
                if (this.constraints.length.min !== null && this.constraints.length.min > 0) {
                    if (val.length < this.constraints.length.min && val.length > 0) {
                        this.errors.push(
                            this.translator(
                                "identityField.cantBeLessThenChars", {
                                    min: this.constraints.length.min
                                }
                            )
                        )
                    }
                }
            }
            
            
            
            if (this.constraints.not_allowed_words !== undefined) {
                let notAllowedWords = this.constraints.not_allowed_words.split(",")
                notAllowedWords.forEach(word => {
                    word = word.trim()

                    if (word != "") {
                        if (val.indexOf(word) !== -1) {
                            this.errors.push(this.translator(
                                "identityField.wordNotAllowed", {
                                    word: word
                                }
                            ))
                        }  
                    }              
                })
            }

            if (this.constraints.regex !== undefined || this.constraints.regex !== "") {
                let re = new RegExp(this.constraints.regex)
                if (! re.test(val)) {
                    this.errors.push(this.translator("identityField.invalidInput"))
                }
            }
                
            this.$emit("error", {field: this.field.key, error: this.errors.length > 0})
        },
        
        getColor: function () {
            if (!this.editor) return "#00000";
            return this.colorInHex(this.editor.getAttributes("textStyle").color);
        },

        getFontFamily: function () {
            const { fontFamily = "Arial" } = this.editor.getAttributes("textStyle")
            return fontFamily || "Arial";
        },

        changeFontFamily(font) {
            this.editor.chain().focus().setFontFamily(font).run()
            this.fontFamily = font
        },

        colorInHex: function (rgbColor) {
            if (!rgbColor) return "#000000";

            if (rgbColor.startsWith("#")) {
                return rgbColor;
            }

            const values = rgbColor.match(/\d+/g);
            if (!values || values.length !== 3) {
                throw new Error("Invalid RGB color format");
            }

            const hexValues = values.map((value) => {
                const hex = parseInt(value, 10).toString(16);
                return hex.length === 1 ? "0" + hex : hex;
            });

            return "#" + hexValues.join("").toUpperCase();
        },

        colorPicker() {
            console.log(document.getElementById("colorPicker"))
            document.getElementById("colorPicker").click()
        },

        triggerImageImport() {
            document.getElementById("imageImport").click()
        },

        imageChoosen(val) {
            const reader = new FileReader();
            reader.onloadend = () => {
                this.editor.commands.setImage({
                    src: reader.result,
                })
            };

            reader.onerror = () => {

            };
            reader.readAsDataURL(val);
        }

    },

    mounted() {
        const CustomTableCell = TableCell.extend({
            addAttributes() {
                return {
                ...this.parent(),

                color: {
                    default: '#000',
                    parseHTML: element => element.style.color || '#000',
                    renderHTML: attributes => {
                    return {
                        style: `color: ${attributes.color}`,
                    };
                    },
                },

                borderStyle: {
                    default: '2px solid #000',
                    parseHTML: element => element.style.borderStyle || '2px solid #000',
                    renderHTML: attributes => {
                        console.log("borderStyleTableCell", attributes)
                    return {
                        style: `border: ${attributes.borderStyle}`,
                    };
                    },
                },

                backgroundColor: {
                    default: null,
                    parseHTML: element => element.getAttribute('data-background-color'),
                    renderHTML: attributes => {
                    return {
                        'data-background-color': attributes.backgroundColor,
                        style: `background-color: ${attributes.backgroundColor}`,
                    }
                    },
                },
                style: {
                    default: 'height: 28px; padding: 3px 5px; margin: 0px;'
                }
                }
            }
        })

        const CustomTable = Node.create({
            name: 'tableCustom',

            isolating: true,

            parseHTML() {
                return [
                    {tag: 'table'}
                ]
            },

            renderHTML({ HTMLAttributes }) {
                return ['table', HTMLAttributes, 0]
            },

            addAttributes() {
                return {
                    style: {
                        default: 'border-collapse: collapse;'
                    }
                }
            }
        })

        const HardBreakEnter = HardBreak.extend({
            addKeyboardShortcuts() {
                return {
                    'Enter': () => this.editor.commands.setHardBreak()
                }
            }
        })

        const FontSize = Extension.create({
            name: "fontSize",

            addOptions() {
                return {
                    types: ["textStyle"],
                };
            },

            addGlobalAttributes() {
                return [
                {
                    types: this.options.types,
                    attributes: {
                    fontSize: {
                        default: null,
                        parseHTML: (element) =>
                        element.style.fontSize.replace(/['"]+/g, ""),
                        renderHTML: (attributes) => {
                        if (!attributes.fontSize) {
                            return {};
                        }

                        return {
                            style: `font-size: ${attributes.fontSize}`,
                        };
                        },
                    },
                    },
                },
                ];
            },

            addCommands() {
                return {
                setFontSize:
                    (fontSize) =>
                    ({ chain }) => {
                    return chain().setMark("textStyle", { fontSize }).run();
                    },
                unsetFontSize:
                    () =>
                    ({ chain }) => {
                    return chain()
                        .setMark("textStyle", { fontSize: null })
                        .removeEmptyTextStyle()
                        .run();
                    },
                };
            },
        });

        const ImageResize = Image.extend({
            addAttributes() {
                return {
                src: {
                    default: null,
                },
                alt: {
                    default: null,
                },
                style: {
                    default: 'width: 100%; height: auto; cursor: pointer;',
                    parseHTML: element => {
                    const width = element.getAttribute('width');
                    return width
                        ? `width: ${width}px; height: auto; cursor: pointer;`
                        : `${element.style.cssText}`;
                    },
                },
                title: {
                    default: null,
                },
                loading: {
                    default: null,
                },
                srcset: {
                    default: null,
                },
                sizes: {
                    default: null,
                },
                crossorigin: {
                    default: null,
                },
                usemap: {
                    default: null,
                },
                ismap: {
                    default: null,
                },
                width: {
                    default: null,
                },
                height: {
                    default: null,
                },
                referrerpolicy: {
                    default: null,
                },
                longdesc: {
                    default: null,
                },
                decoding: {
                    default: null,
                },
                class: {
                    default: null,
                },
                id: {
                    default: null,
                },
                name: {
                    default: null,
                },
                draggable: {
                    default: true,
                },
                tabindex: {
                    default: null,
                },
                'aria-label': {
                    default: null,
                },
                'aria-labelledby': {
                    default: null,
                },
                'aria-describedby': {
                    default: null,
                },
                };
            },
            addNodeView() {
                return ({ node, editor, getPos }) => {
                const {
                    view,
                    options: { editable },
                } = editor;
                const { style } = node.attrs;
                const $wrapper = document.createElement('div');
                const $container = document.createElement('div');
                const $img = document.createElement('img');
                const iconStyle = 'width: 24px; height: 24px; cursor: pointer;';

                const dispatchNodeView = () => {
                    if (typeof getPos === 'function') {
                    const newAttrs = {
                        ...node.attrs,
                        style: `${$img.style.cssText}`,
                    };
                    view.dispatch(view.state.tr.setNodeMarkup(getPos(), null, newAttrs));
                    }
                };
                const paintPositionContoller = () => {
                    const $postionController = document.createElement('div');

                    const $leftController = document.createElement('img');
                    const $centerController = document.createElement('img');
                    const $rightController = document.createElement('img');

                    const controllerMouseOver = e => {
                    e.target.style.opacity = 0.3;
                    };

                    const controllerMouseOut = e => {
                    e.target.style.opacity = 1;
                    };

                    $postionController.setAttribute(
                    'style',
                    'position: absolute; top: 0%; left: 50%; width: 100px; height: 25px; z-index: 999; background-color: rgba(255, 255, 255, 0.7); border-radius: 4px; border: 2px solid #6C6C6C; cursor: pointer; transform: translate(-50%, -50%); display: flex; justify-content: space-between; align-items: center; padding: 0 10px;',
                    );

                    $leftController.setAttribute(
                    'src',
                    'https://fonts.gstatic.com/s/i/short-term/release/materialsymbolsoutlined/format_align_left/default/20px.svg',
                    );
                    $leftController.setAttribute('style', iconStyle);
                    $leftController.addEventListener('mouseover', controllerMouseOver);
                    $leftController.addEventListener('mouseout', controllerMouseOut);

                    $centerController.setAttribute(
                    'src',
                    'https://fonts.gstatic.com/s/i/short-term/release/materialsymbolsoutlined/format_align_center/default/20px.svg',
                    );
                    $centerController.setAttribute('style', iconStyle);
                    $centerController.addEventListener('mouseover', controllerMouseOver);
                    $centerController.addEventListener('mouseout', controllerMouseOut);

                    $rightController.setAttribute(
                    'src',
                    'https://fonts.gstatic.com/s/i/short-term/release/materialsymbolsoutlined/format_align_right/default/20px.svg',
                    );
                    $rightController.setAttribute('style', iconStyle);
                    $rightController.addEventListener('mouseover', controllerMouseOver);
                    $rightController.addEventListener('mouseout', controllerMouseOut);

                    $leftController.addEventListener('click', () => {
                    $img.setAttribute('style', `${$img.style.cssText} margin: 0 auto 0 0;`);
                    dispatchNodeView();
                    });
                    $centerController.addEventListener('click', () => {
                    $img.setAttribute('style', `${$img.style.cssText} margin: 0 auto;`);
                    dispatchNodeView();
                    });
                    $rightController.addEventListener('click', () => {
                    $img.setAttribute('style', `${$img.style.cssText} margin: 0 0 0 auto;`);
                    dispatchNodeView();
                    });

                    $postionController.appendChild($leftController);
                    $postionController.appendChild($centerController);
                    $postionController.appendChild($rightController);

                    $container.appendChild($postionController);
                };

                $wrapper.setAttribute('style', `display: flex;`);
                $wrapper.appendChild($container);

                $container.setAttribute('style', `${style}`);
                $container.appendChild($img);

                Object.entries(node.attrs).forEach(([key, value]) => {
                    if (value === undefined || value === null) return;
                    $img.setAttribute(key, value);
                });

                if (!editable) return { dom: $img };

                const dotsPosition = [
                    'top: -4px; left: -4px; cursor: nwse-resize;',
                    'top: -4px; right: -4px; cursor: nesw-resize;',
                    'bottom: -4px; left: -4px; cursor: nesw-resize;',
                    'bottom: -4px; right: -4px; cursor: nwse-resize;',
                ];

                let isResizing = false;
                let startX, startWidth;

                $container.addEventListener('click', () => {
                    //remove remaining dots and position controller
                    if ($container.childElementCount > 3) {
                    for (let i = 0; i < 5; i++) {
                        $container.removeChild($container.lastChild);
                    }
                    }

                    paintPositionContoller();

                    $container.setAttribute(
                    'style',
                    `position: relative; border: 1px dashed #6C6C6C; ${style} cursor: pointer;`,
                    );

                    Array.from({ length: 4 }, (_, index) => {
                    const $dot = document.createElement('div');
                    $dot.setAttribute(
                        'style',
                        `position: absolute; width: 9px; height: 9px; border: 1.5px solid #6C6C6C; border-radius: 50%; ${dotsPosition[index]}`,
                    );

                    $dot.addEventListener('mousedown', e => {
                        e.preventDefault();
                        isResizing = true;
                        startX = e.clientX;
                        startWidth = $container.offsetWidth;

                        const onMouseMove = (e) => {
                        if (!isResizing) return;
                        const deltaX = index % 2 === 0 ? -(e.clientX - startX) : e.clientX - startX;

                        const newWidth = startWidth + deltaX;

                        $container.style.width = newWidth + 'px';

                        $img.style.width = newWidth + 'px';
                        };

                        const onMouseUp = () => {
                        if (isResizing) {
                            isResizing = false;
                        }
                        dispatchNodeView();

                        document.removeEventListener('mousemove', onMouseMove);
                        document.removeEventListener('mouseup', onMouseUp);
                        };

                        document.addEventListener('mousemove', onMouseMove);
                        document.addEventListener('mouseup', onMouseUp);
                    });
                    $container.appendChild($dot);
                    });
                });

                document.addEventListener('click', (e) => {
                    const $target = e.target;
                    const isClickInside = $container.contains($target) || $target.style.cssText === iconStyle;

                    if (!isClickInside) {
                    const containerStyle = $container.getAttribute('style');
                    const newStyle = containerStyle.replace('border: 1px dashed #6C6C6C;', '');
                    $container.setAttribute('style', newStyle);

                    if ($container.childElementCount > 3) {
                        for (let i = 0; i < 5; i++) {
                        $container.removeChild($container.lastChild);
                        }
                    }
                    }
                });

                return {
                    dom: $wrapper,
                };
                };
            },
        })

        this.editor = new Editor({
            extensions: [
                StarterKit.configure({
                    history: true,
                    document: true,
                    code: true,
                    codeBlock: true,
                    dropcursor: true,
                    gapcursor: true,
                    italic: true,
                    listItem: true,
                    orderedList: true,
                    paragraph: true,
                    strike: true,
                    text: true,
                    hardBreak: true
                }),
                TextAlign.configure({
                    types: ['heading', 'paragraph']
                }),
                Highlight,
                Color,
                TextStyle,
                Image.configure({
                    allowBase64: true,
                    inline: true
                }),
                Table.configure({
                    resizable: true,
                }),
                TableRow,
                TableHeader,
                TableCell,
                CustomTableCell,
                FontFamily.configure({
                    types: ['textStyle'],
                }),
                FontSize,
                ImageResize,
                HardBreakEnter,
                CustomTable,
            ],
            content: this.content,

            onUpdate: ({ editor }) => {
                // Emit an input event when the content changes (similar to v-model)
                this.content = editor.getHTML();
            }

        });

        this.editor.chain().focus().setColor(this.defaultColor).run()
        this.textColor = this.defaultColor
        this.fontFamily = this.getFontFamily()

        this.editor.on("selectionUpdate", ({editor}) => {
            this.textColor = this.getColor();
            this.fontFamily = this.getFontFamily()

            this.currentSelection = editor.chain().focus()

            const selection = editor.state.selection;
            // const mainNode = editor.state.doc.nodeAt(0);

            // if (!mainNode) return;

            // const isOutsideMain =
            //     selection.from <= mainNode.content.findDiffStart(mainNode.content) ||
            //     selection.to > mainNode.content.size;

            // if (isOutsideMain) {
            //     editor.commands.setTextSelection(mainNode.content.findDiffStart(mainNode.content) || 0);
            // }
        });
    }
}
</script>


<style lang="scss" scoped>
.button-group > * {
    margin: 5px;
    display: inline-block;
} 

.button-group {
    position: sticky;
    border-bottom: 1px solid #ccc;
    padding-bottom: 10px;
    background-color: #fff;
    margin-top: 0px;
    z-index: 9999;
}

.control-group {
    width: 100%;
}

.editor-container {
    position: relative;
    background-color: #fff;
    padding-bottom: 10px;
    border-style: solid;
    border-top: 1px solid #fff;
    border-bottom: 1px solid #fff;
    border-right: none;
    border-left: none;
    margin: 0;

    .editor {
        margin-top: 0px;
        padding: 10px;
        color: #000;
        max-height: 800px;
        overflow-y: scroll;
    }

    .form-control {
        height: calc(1.5em + 0.75rem + 2px);
        padding: 0.375rem 0.75rem;
        font-size: 0.875rem;
        font-weight: 400;
        line-height: 1.5;
        color: #5c6873;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid #e4e7ea;
        border-radius: 0.25rem;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    }

  .currentSettings .btn {
    margin: 5px;
  }
}
</style>

<style lang="scss">
.ProseMirror-focused {
    outline: none;
}

/* Basic editor styles */
.tiptap {
  :first-child {
    margin-top: 0;
  }

  /* Table-specific styling */
  table {

    td,
    th {
      border: 1px solid var(--gray-3);
      box-sizing: border-box;
      min-width: 1em;
      padding: 6px 8px;
      position: relative;
      vertical-align: top;

      > * {
        margin-bottom: 0;
      }
    }

    th {
      background-color: var(--gray-1);
      font-weight: bold;
      text-align: left;
    }

    .selectedCell:after {
      background: var(--gray-2);
      content: "";
      left: 0; right: 0; top: 0; bottom: 0;
      pointer-events: none;
      position: absolute;
      z-index: 2;
    }

    .column-resize-handle {
      background-color: var(--purple);
      bottom: -2px;
      pointer-events: none;
      position: absolute;
      right: -2px;
      top: 0;
      width: 4px;
    }
  }

  .tableWrapper {
    margin: 1.5rem 0;
    overflow-x: auto;
  }

  &.resize-cursor {
    cursor: ew-resize;
    cursor: col-resize;
  }
}
</style>